<template>
    <section class="pt-3" id="destination">
  
      <div class="container">
        <div class="position-absolute start-100 bottom-0 translate-middle-x d-none d-xl-block ms-xl-n4"><img
            src="../../assets/img/dest/shape.svg" alt="destination" /></div>
        <div class="mb-7 text-center">
          <h5 class="text-secondary">User Choice </h5>
          <h3 class="fs-xl-10 fs-lg-8 fs-7 fw-bold font-cursive text-capitalize">Top Four Destinations</h3>
        </div>
        <div class="row">
          <div class="col-md-3 mb-3">
            <div class="card overflow-hidden shadow"> <img class="card-img-top" src="https://d1ynolcus8dvgv.cloudfront.net/2019/01/nine-arch-2-5.jpg"
                alt="Rome, Italty" />
              <div class="card-body py-4 px-3">
                <div class="d-flex flex-column flex-lg-row justify-content-between mb-3">
                  <h4 class="text-secondary fw-medium"><a class="link-900 text-decoration-none stretched-link"
                      href="#!">Elle, Srilanka</a></h4><span class="fs-1 fw-medium"></span>
                </div>
                <div class="d-flex align-items-center"> <img src="../../assets/img/dest/navigation.svg"
                    style="margin-right: 14px" width="20" alt="navigation" /><span class="fs-0 fw-medium">Make Your
                    Trip</span></div>
              </div>
            </div>
          </div>
          <div class="col-md-3 mb-3">
            <div class="card overflow-hidden shadow"> <img class="card-img-top" src="https://d2r2v0jxjsbm0p.cloudfront.net/2020/12/parrot-rock-1000.jpg"
                alt="London, UK" />
              <div class="card-body py-4 px-3">
                <div class="d-flex flex-column flex-lg-row justify-content-between mb-3">
                  <h4 class="text-secondary fw-medium"><a class="link-900 text-decoration-none stretched-link"
                      href="#!">Mirissa, Srilanka</a></h4><span class="fs-1 fw-medium"></span>
                </div>
                <div class="d-flex align-items-center"> <img src="../../assets/img/dest/navigation.svg"
                  style="margin-right: 14px" width="20" alt="navigation" /><span class="fs-0 fw-medium">Make Your
                    Trip</span></div>
              </div>
            </div>
          </div>
          <div class="col-md-3 mb-3">
            <div class="card overflow-hidden shadow"> <img class="card-img-top" src="https://d3gpg9xwvhoccm.cloudfront.net/2019/03/south-west-tour-3-2.jpg"
                alt="Full Europe" />
              <div class="card-body py-4 px-3">
                <div class="d-flex flex-column flex-lg-row justify-content-between mb-3">
                  <h4 class="text-secondary fw-medium"><a class="link-900 text-decoration-none stretched-link"
                      href="#!">Kandy, Srilanka</a></h4><span class="fs-1 fw-medium"></span>
                </div>
                <div class="d-flex align-items-center"> <img src="../../assets/img/dest/navigation.svg"
                  style="margin-right: 14px" width="20" alt="navigation" /><span class="fs-0 fw-medium">Make Your
                    Trip</span></div>
              </div>
            </div>
          </div>
          <div class="col-md-3 mb-3">
            <div class="card overflow-hidden shadow"> <img class="card-img-top" src="https://dgb8xu5uhrytd.cloudfront.net/2023/02/inbound-tours-mob-header.jpg"
                alt="Full Europe" />
              <div class="card-body py-4 px-3">
                <div class="d-flex flex-column flex-lg-row justify-content-between mb-3">
                  <h4 class="text-secondary fw-medium"><a class="link-900 text-decoration-none stretched-link"
                      href="#!">Galle, Srilanka</a></h4><span class="fs-1 fw-medium"></span>
                </div>
                <div class="d-flex align-items-center"> <img src="../../assets/img/dest/navigation.svg"
                  style="margin-right: 14px" width="20" alt="navigation" /><span class="fs-0 fw-medium">Make Your
                    Trip</span></div>
              </div>
            </div>
          </div>
        </div>
      </div><!-- end of .container-->
  
    </section>
  </template>
  
  <script>
  export default {
    name: 'PlacesPage'
  }
  </script>
  
  <style></style>